import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { LoaderComponent } from './loader/loader.component';
import { QuoteInformationComponent } from './components/quote-information/quote-information.component';
import { PlanDetailDialogComponent } from './components/plan-detail-dialog/plan-detail-dialog.component';
import { NewsletterComponent } from './components/newsletter/newsletter.component';
import { PlanDetailModalComponent } from './components/plan-detail-modal/plan-detail-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbModule],
  providers: [],
  declarations: [LoaderComponent, QuoteInformationComponent, PlanDetailDialogComponent, NewsletterComponent, PlanDetailModalComponent],
  exports: [TranslateModule, LoaderComponent, QuoteInformationComponent, PlanDetailDialogComponent, NewsletterComponent, PlanDetailModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
